import Vue from "vue";

// 全局响应式会话状态：钱包地址 + 应用侧链标识 + 钱包真实 EVM chainId。
// storage 变化不会触发 Vue 更新，所以用一个 observable 统一持有，
// 连接钱包/切链后即时刷新头部等 UI。

function readAddr() {
  return sessionStorage.getItem("ADDRESS") || localStorage.getItem("U_ADDRESS") || "";
}

function readChain() {
  return sessionStorage.getItem("CHAIN") || "";
}

function readEvmChainId() {
  try {
    return (window.ethereum && window.ethereum.chainId) || "";
  } catch (e) {
    return "";
  }
}

export const sessionState = Vue.observable({
  address: readAddr(),
  chain: readChain(), // 应用侧标识：ERC20 / BASE / TRC20 / SOL
  evmChainId: readEvmChainId(), // 钱包真实 chainId（十六进制），头部据此显示网络
});

export function setAddress(addr) {
  sessionState.address = addr || readAddr();
}

export function setChain(chain) {
  sessionState.chain = chain || readChain();
}

export function setEvmChainId(id) {
  sessionState.evmChainId = id || readEvmChainId();
}

// 从 storage 重新同步（用于初始化或外部写入后兜底）
export function syncAddress() {
  sessionState.address = readAddr();
  sessionState.chain = readChain();
}

// 钱包的 chainChanged / accountsChanged 监听改由 wallet-session 的 bindWalletEvents 统一绑定：
// provider 常常晚于本模块 import 才注入，在这里绑会漏掉。
